import { render, staticRenderFns } from "./InitialReservationItem.vue?vue&type=template&id=2fbfcf06&scoped=true&"
import script from "./InitialReservationItem.vue?vue&type=script&lang=js&"
export * from "./InitialReservationItem.vue?vue&type=script&lang=js&"
import style0 from "./InitialReservationItem.vue?vue&type=style&index=0&id=2fbfcf06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbfcf06",
  null
  
)

export default component.exports